/* eslint-disable camelcase */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BluebirdPromise from 'bluebird';
import { isEqual, isEmpty, includes, get } from 'lodash';
import { withRouter, Prompt } from 'react-router-dom';
import { change, getFormValues } from 'redux-form';
import Page from '../../../shared/components/Page';
import RoutingTabs from '../../../shared/components/RoutingTabs';
import {
    LEARNING_ASSET_TYPES,
    ROUTE_PREFIXES,
    ASSET_METADATA_CATEGORIES,
    ASSET_METADATA_LOOKUP
} from '../../../shared/Constants';

import { postLearningAsset, putLearningAsset, getLearningAsset } from '../../../shared/actions';
import { postWelcomeAsset, putWelcomeAsset, getWelcomeAsset } from '../../../shared/actions/WelcomeAssets';

import TrackV2Form from '../forms/Admin/TrackV2Form/TrackV2Form';
import VerbBreadcrumb from '../../../shared/components/history/VerbBreadcrumb';
import { RuntimeContext } from '../../../../common/RuntimeContext';

class AddOrEditLearningAsset extends Component {
    static propTypes = {
        getLearningAsset: PropTypes.func.isRequired,
        postLearningAsset: PropTypes.func.isRequired,
        putLearningAsset: PropTypes.func.isRequired,
        getWelcomeAsset: PropTypes.func.isRequired,
        postWelcomeAsset: PropTypes.func.isRequired,
        putWelcomeAsset: PropTypes.func.isRequired,
        changeFormValue: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        loggedInUser: PropTypes.object.isRequired,
        userCompany: PropTypes.object.isRequired,
        currentValues: PropTypes.object
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        let currentLearningAsset = {};
        if (props.location.state && props.location.state.existingObject) {
            currentLearningAsset = props.location.state.existingObject;
        }

        if (props.location.state && props.location.state.sections) {
            currentLearningAsset = {
                type: props.location.state.type,
                sections: props.location.state.sections
            };

            const { name, subtitle, participants, durationId } = props.location.state;
            currentLearningAsset = {
                ...currentLearningAsset,
                name,
                subtitle,
                participants,
                durationId
            };
        }
        const availableRoutes = [
            {
                tabName: 'Summary',
                path: `${this._getBasePath(this.props)}/summary`,
                relativePath: '/summary',
                exact: true,
                state: {
                    type: get(props, 'location.state.type', ''),
                    sections: get(props, 'location.state.sections', {})
                }
            },
            {
                tabName: 'Builder',
                path: `${this._getBasePath(this.props)}/builder`,
                relativePath: '/builder',
                exact: true,
                state: {
                    type: get(props, 'location.state.type', ''),
                    sections: get(props, 'location.state.sections', {})
                }
            },
            {
                tabName: 'Prompts',
                path: `${this._getBasePath(this.props)}/prompts`,
                relativePath: '/prompts',
                exact: true,
                state: {
                    type: get(props, 'location.state.type', ''),
                    sections: get(props, 'location.state.sections', {})
                }
            }
        ];

        this.state = {
            availableRoutes,
            masterValidation: {},
            currentLearningAsset,
            isCopied: false,
            isWelcomeAsset: false,
            childFormIsDirty: false
        };
    }

    setIsFormDirty = (value) => {
        this.setState({
            childFormIsDirty: value
        });
    };

    componentDidMount() {
        const { match, getLearningAsset, getWelcomeAsset, loggedInUser } = this.props;
        const isWelcomeAsset = this._isWelcomeAsset(match.path);
        this.setState({ isWelcomeAsset });

        if (match.params.id) {
            let getAssetPromise;
            if (isWelcomeAsset) {
                getAssetPromise = getWelcomeAsset({
                    welcomeAssetId: match.params.id,
                    pathsContext: this.context.pathsWeb
                });
            } else {
                getAssetPromise = getLearningAsset({
                    learningAssetId: match.params.id,
                    getFullProjection: true,
                    pathsContext: this.context.pathsWeb
                });
            }
            return getAssetPromise.then((retrievedAsset) => {
                this.setState({
                    currentLearningAsset: retrievedAsset
                });
            });
        }
        return null;
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this._getBasePath(nextProps) !== this._getBasePath(this.props)) {
            const newRoutes = this.state.availableRoutes.map((item) => {
                item.path = `${this._getBasePath(nextProps)}${item.relativePath}`;
                return item;
            });
            this.setState({ availableRoutes: newRoutes });
        }
    }

    _isWelcomeAsset = (path = '') =>
        path.startsWith(ROUTE_PREFIXES.NEW_WELCOME_ASSET) || path.startsWith(ROUTE_PREFIXES.EDIT_WELCOME_ASSET);

    _getBasePath = (props) => {
        const isWelcomeAsset = this._isWelcomeAsset(props.match.path);
        const path = isWelcomeAsset ? 'welcome' : 'learning';
        let relativePath = `/new${path}asset`;
        if (get(props, 'match.params.id', '')) {
            relativePath = `/edit${path}asset/${props.match.params.id}`;
        }

        return relativePath;
    };

    _removeEmptyPrompts = (values) => {
        if (values.prompts) {
            const cleanedValues = values.prompts.filter(({ value, showOption }) => value && showOption);
            values.prompts = cleanedValues;
        }

        return values;
    };

    handleSubmit = (exitOnSave, values, initialize) => {
        const {
            putLearningAsset,
            postLearningAsset,
            putWelcomeAsset,
            postWelcomeAsset,
            loggedInUser,
            userCompany,
            changeFormValue
        } = this.props;
        const { currentLearningAsset, isCopied } = this.state;
        const cleanedValues = this._removeEmptyPrompts({ ...values });
        const newLearningAsset = Object.assign({}, currentLearningAsset, cleanedValues);
        const isWelcomeAsset = newLearningAsset.type === LEARNING_ASSET_TYPES.WELCOME;
        let submitPromise = BluebirdPromise.resolve();
        let isNew = false;

        newLearningAsset.metadataTags = (newLearningAsset.metadataTags || []).map((tag) => ({ id: tag.id }));
        if (!newLearningAsset._id || (newLearningAsset._id && isCopied)) {
            isNew = true;
            newLearningAsset.author = {
                _id: loggedInUser._id,
                firstName: loggedInUser.firstName,
                lastName: loggedInUser.lastName,
                companyName: userCompany.name
            };

            delete newLearningAsset._id;
            delete newLearningAsset.revision;
            delete newLearningAsset.createdOn;
            delete newLearningAsset.updatedOn;
            if (isWelcomeAsset) {
                submitPromise = postWelcomeAsset({ body: newLearningAsset, pathsContext: this.context.pathsWeb });
            } else {
                submitPromise = postLearningAsset({ body: newLearningAsset, pathsContext: this.context.pathsWeb });
            }
        } else if (!isEqual(newLearningAsset, currentLearningAsset)) {
            if (isWelcomeAsset) {
                submitPromise = putWelcomeAsset({
                    welcomeAssetId: newLearningAsset._id,
                    body: newLearningAsset,
                    pathsContext: this.context.pathsWeb
                });
            } else {
                submitPromise = putLearningAsset({
                    learningAssetId: newLearningAsset._id,
                    body: newLearningAsset,
                    pathsContext: this.context.pathsWeb
                });
            }
        }

        if (exitOnSave) {
            return submitPromise.then((result) => {
                localStorage.removeItem(`assetBackup`);
                this.props.history.push('/managelearningassets');
                return result;
            });
        }
        if (isNew) {
            return submitPromise.then((result) => {
                this.setState({
                    currentLearningAsset: result
                });
                changeFormValue({ field: 'author', value: newLearningAsset.author });
                localStorage.removeItem(`assetBackup`);
                const path = result.type === LEARNING_ASSET_TYPES.WELCOME ? 'welcome' : 'learning';
                this.props.history.push(`/edit${path}asset/${result._id}/summary`);
                return result;
            });
        }
        return submitPromise.then((result) => {
            const formValuesForInitialize = { ...result };
            formValuesForInitialize.metadataTags = (formValuesForInitialize.metadataTags || []).map((tag) => {
                const currentMetadata = ASSET_METADATA_LOOKUP[tag.id];
                return {
                    ...tag,
                    label: `${ASSET_METADATA_CATEGORIES[currentMetadata.categoryId].label}: ${currentMetadata.label}`
                };
            });
            if (initialize) {
                initialize(formValuesForInitialize);
            }
            this.setState({ currentLearningAsset: result });
            return result;
        });
    };

    handleCancel = () => {
        this.props.history.push('/managelearningassets');
    };

    activityIsUnsaved = () => {
        const { currentValues } = this.props;
        const { childFormIsDirty, currentLearningAsset } = this.state;

        const cleanedValues = this._removeEmptyPrompts({ ...currentValues });
        const newLearningAsset = Object.assign({}, currentLearningAsset, cleanedValues);

        return (
            childFormIsDirty || !newLearningAsset._id // is new activity
        );
    };

    render() {
        const { location } = this.props;
        const { currentLearningAsset, isWelcomeAsset } = this.state;
        const isNew = includes(location.pathname, 'new');
        if (isNew || !isEmpty(currentLearningAsset)) {
            return (
                <Page className={'learning-asset-builder'}>
                    <Prompt
                        when={this.activityIsUnsaved()}
                        message={'You have unsaved changes, are you sure you want to leave without saving changes?'}
                    />
                    <div className={'builder-breadcrumb'}>
                        <VerbBreadcrumb
                            isBuilderNavigation={true}
                            currentLearningAssetName={currentLearningAsset.name}
                            className={'offset-3'}
                        />
                    </div>
                    <div className={'row builder-routing-tabs'}>
                        <div className={'tab-container col-3'}>
                            <p>{this.state.masterValidation.message}</p>
                            <RoutingTabs routeTabs={this.state.availableRoutes} tabAlignment={'left'} />
                        </div>
                    </div>
                    <div className={'trackWrapper adminWrapper'}>
                        {!isEmpty(currentLearningAsset.sections) && (
                            <TrackV2Form
                                isCopied={true}
                                track={currentLearningAsset}
                                type={currentLearningAsset.type}
                                isNew={isNew}
                                isWelcomeAsset={isWelcomeAsset}
                                onSubmit={this.handleSubmit}
                                onCancel={this.handleCancel}
                                cleanPrompts={this._removeEmptyPrompts}
                                setIsFormDirty={this.setIsFormDirty}
                            />
                        )}
                    </div>
                </Page>
            );
        }
        return null;
    }
}

const mapStateToProps = (state) => {
    const {
        companies,
        auth: { isAuthenticated, loggedInUser, isContentAuthor, isVerbAdmin, loggedInUserCompanyId }
    } = state;

    const userCompany = companies.byId[loggedInUserCompanyId] || {};
    return {
        isAuthenticated,
        isContentAuthor,
        isVerbAdmin,
        loggedInUser,
        userCompany,
        currentValues: getFormValues('TrackV2')(state)
    };
};

const mapDispatchToProps = (dispatch) => ({
    postLearningAsset: (params) => dispatch(postLearningAsset(params)),
    putLearningAsset: (params) => dispatch(putLearningAsset(params)),
    getLearningAsset: (params) => dispatch(getLearningAsset(params)),
    getWelcomeAsset: (params) => dispatch(getWelcomeAsset(params)),
    postWelcomeAsset: (params) => dispatch(postWelcomeAsset(params)),
    putWelcomeAsset: (params) => dispatch(putWelcomeAsset(params)),
    changeFormValue: (params) => dispatch(change('TrackV2', params.field, params.value))
});

export const AddOrEditLearningAssetComponent = AddOrEditLearningAsset;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddOrEditLearningAsset));
